import styled from "styled-components";

export const Wrapper = styled.header<{ $doubleBar?: boolean; $darkMode: boolean }>`
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 0;
    z-index: 80;
    background: ${({ theme, $darkMode }) =>
        $darkMode ? theme.v2.colors["background-primary-200"] : theme.v2.colors["background-primary-base"]};
    height: ${({ $doubleBar }) => ($doubleBar ? "128px" : "64px")};
`;

export const BaseBar = styled.div<{ $darkMode: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${({ theme, $darkMode }) =>
        $darkMode ? theme.v2.colors["background-primary-200"] : theme.v2.colors["background-primary-base"]};
    box-shadow: inset 0px -1px 0px ${({ theme }) => theme.v2.colors["border-primary-100"]};
    height: 64px;
    padding: 0 32px;
`;

export const SecondBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    padding: 14px 32px;
    box-shadow: inset 0px -1px 0px ${({ theme }) => theme.v2.colors["border-primary-100"]};
`;

export const ActionsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    width: 100%;

    > * + * {
        margin-left: 12px;
    }
`;

export const SearchWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const Tabs = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    a:first-child {
        margin-left: 0;
    }
`;

export const TitleWrapper = styled.p`
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${({ theme }) => theme.v2.colors["text-primary-1200"]};
`;

export const BaseSection = styled.div`
    display: flex;
    align-items: center;
`;

export const SideBarButtonWrapper = styled.div`
    margin-right: 16px;
`;
